import React from "react";
import {
  Grid,
  Box,
  Autocomplete,
  TextField,
  List,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import TopViewNav from "../CommonComponents/TopViewNav";
import { CompanyAndUsersData } from "../../actions/CompanyAndUsers";
import { PermissionMasterAction } from "../../actions/PermissionMaster";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const ClientPermissionConfiguration = ({ userList }) => {
  const [companyList, setCompanyList] = React.useState([]);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  //   const [userList, setUserList] = React.useState([]);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [selectedPermission, setSelectedPermission] = React.useState([]);
  const [permissionInputVal, setPermissionInputVal] = React.useState("");
  const [userExistingPermission, setUserExistingPermission] = React.useState(
    []
  );
  const [allPermission, setAllPermission] = React.useState([]);
  const [permissionList, setPermissionList] = React.useState([]);

  const fetchCompanyList = async () => {
    const res = await CompanyAndUsersData.fetchCompanyAndUserList();
    if (res !== null) {
      setCompanyList(res.data);
    } else {
      setCompanyList([]);
    }
  };

  //   const fetchUsersListBySelectedCompany = async () => {
  //     const res = await PermissionMasterAction.getCompanyWiseUser({
  //       // companyId: selectedCompany.id,
  //       companyId: JSON.parse(localStorage.getItem("CompanyIdSelect")).id,
  //     });
  //     if (res !== null && res.data[0]) {
  //       setUserList(res.data[0].userDtoList || []);
  //     } else {
  //       setUserList([]);
  //     }
  //   };

  const getUserExistingPermission = async (userId) => {
    const res = await PermissionMasterAction.getUserPermissionByUserId({
      userId,
    });
    if (res && res.responseCode === 200) {
      setUserExistingPermission(res.data);
      const userExistingPermissionStrArr = res.data.map(
        (item) => item.sfaPermissionDTO?.sfaPermissionName
      );
      setPermissionList(
        allPermission.filter(
          (item) =>
            !userExistingPermissionStrArr.includes(item.sfaPermissionName)
        )
      );
    } else {
      setUserExistingPermission([]);
      setPermissionList([]);
    }
  };

  const getAllPermissionList = async () => {
    const res = await PermissionMasterAction.getAllPermission();
    if (res !== null) {
      setAllPermission(res.data);
    } else {
      setAllPermission([]);
    }
  };

  const savePermissionForUser = async () => {
    const response = await companyWiseEmp.fetchSavePermissionForUser({
      userId: selectedUser.id,
      permissionids: selectedPermission.map((item) => item.id),
    });
    if (response && response.responseCode === 200) {
      alert(response.responseDescription);
      setSelectedPermission([]);
      setPermissionInputVal("");
      getUserExistingPermission(selectedUser.id);
    } else {
      alert("Something Went Wrong");
    }
  };

  const handleRemovePermissionForUser = async (permissionDto) => {
    const response = await companyWiseEmp.fetchRemovePermissionForUser({
      // id: permissionDto.id,
      userId: selectedUser.id,
      sfaPermissionId: permissionDto.sfaPermissionId,
    });
    if (response && response.responseCode === 200) {
      alert(response.responseDescription);
      getUserExistingPermission(selectedUser.id);
    } else {
      alert("Something Went Wrong");
    }
  };

  React.useEffect(() => {
    fetchCompanyList();
    getAllPermissionList();
    // fetchUserList();
  }, []);

  // React.useEffect(() => {
  //   if (selectedCompany) {
  //     fetchUsersList();
  //   }
  // }, [selectedCompany]);

  React.useEffect(() => {
    if (selectedUser) {
      getUserExistingPermission(selectedUser.id);
    } else {
      setUserExistingPermission([]);
      setPermissionList([]);
    }
  }, [selectedUser]);
  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            Client Permission Configuration:-
          </h3>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className="accoardian_body">
        <Box sx={{ p: 2 }}>
          <Grid container spacing={3}>
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  size="small"
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  options={userList}
                  getOptionLabel={(option) =>
                    `${option.name}(${option.empCode})`
                  }
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    setSelectedUser(newValue);
                    setSelectedPermission([]);
                    setPermissionInputVal("");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="User"
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  size="small"
                  multiple
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  options={[
                    { id: 0, sfaPermissionName: "Select All" },
                    ...permissionList,
                  ]}
                  getOptionLabel={(option) => `${option.sfaPermissionName}`}
                  disablePortal={true}
                  fullWidth
                  value={selectedPermission}
                  onChange={(event, newValue) => {
                    if (
                      newValue[newValue.length - 1] &&
                      newValue[newValue.length - 1].id === 0
                    ) {
                      setSelectedPermission(permissionList);
                    } else {
                      setSelectedPermission(newValue);
                    }
                  }}
                  inputValue={permissionInputVal}
                  onInputChange={(event, newVal) => {
                    setPermissionInputVal(newVal);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="Permissions"
                    />
                  )}
                />
              </div>
            </Grid>
            {selectedUser && Boolean(selectedPermission.length) && (
              <Grid item>
                <div className="field_box">
                  <Button
                    className="field_box_btn1"
                    onClick={savePermissionForUser}
                    sx={{
                      cursor: "pointer",
                      color: "#fff",
                      textTransform: "none",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {userExistingPermission.map((item, index) => {
                  return (
                    <Box
                      // key={item.id}
                      key={index}
                      sx={{
                        backgroundColor: "#E0DCD6",
                        p: 1.3,
                        borderRadius: 5,
                      }}
                    >
                      {item.sfaPermissionDTO?.sfaPermissionName}
                      <IconButton
                        sx={{ p: 0.4, color: "crimson" }}
                        onClick={() => handleRemovePermissionForUser(item)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ClientPermissionConfiguration;
